import { deleteParkingTowerStopList } from '@esentai/core/features/parkingTowerStopList/actions';
import { connect } from 'react-redux';

import { retryFetch } from '@/features/parkingTowerStopListPage/actions';

import BulkActionsRow from './component';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch, { selectedItems, deselectAll }) => ({
  deleteParkingTowerStopList: () => {
    selectedItems.forEach(id => dispatch(deleteParkingTowerStopList(id)));
    deselectAll();
    setTimeout(() => dispatch(retryFetch()), 400);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkActionsRow);
